import { apiSlice } from "../../app/services/authServices";



export const cycleListApiSlice = apiSlice.injectEndpoints({
    tagTypes: [],
    endpoints: builder => ({

        getProductList: builder.query({
            query: () => ({
                url: '/Order/GetListofProduct',
                method: 'GET',
                keepUnusedDataFor: 0,
                // providesTags: [],
            }),
        }),

    })
})
export const { useGetProductListQuery } = apiSlice;



